import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private globalLoader: Loader;

  public loadingStateChanged$ = new Subject<boolean>();
  public showStateChanged$ = new Subject<boolean>();

  constructor() {
    this.globalLoader = this.createLoader({ name: 'GLOBAL' });

    this.loadingStateChanged$ = this.globalLoader.loadingStateChanged$;
    this.showStateChanged$ = this.globalLoader.showStateChanged$;
  }

  public show() {
    this.globalLoader.start();
  }

  public hide() {
    this.globalLoader.stop();
  }

  public createLoader(options?: LoaderOptions | null): Loader {
    return new Loader(options);
  }
}

export interface LoaderOptions {
  name?: string | null;
  delay?: number | null;
}

export class Loader {
  private DELAY = 750;

  private options: LoaderOptions | null;
  private loaders = 0;
  private isLoading = false;
  private shouldShow = false;

  public loadingStateChanged$: Subject<boolean>;
  public showStateChanged$: Subject<boolean>;

  constructor(options: LoaderOptions) {
    this.options = options;
    this.loadingStateChanged$ = new Subject<boolean>();
    this.showStateChanged$ = new Subject<boolean>();
  }

  public start() {
    const delay = this.options?.delay ? this.options.delay : this.DELAY;

    this.loaders += 1;

    this.updateIsLoading();

    const that = this;
    setTimeout(() => {
      that.updateShouldShow();
    }, delay);
  }

  public stop() {
    if (this.loaders > 0) {
      this.loaders -= 1;
    }
    this.updateIsLoading();
    this.updateShouldShow();
  }

  private updateIsLoading() {
    const newIsLoadingValue = this.loaders > 0;

    if (newIsLoadingValue !== this.isLoading) {
      this.isLoading = newIsLoadingValue;
      this.loadingStateChanged$.next(this.isLoading);
    }
  }

  private updateShouldShow() {
    const newShouldShowValue = this.loaders > 0;

    if (newShouldShowValue !== this.shouldShow) {
      this.shouldShow = newShouldShowValue;
      this.showStateChanged$.next(this.shouldShow);
    }
  }
}
